import { useQuery } from "@tanstack/react-query";
import { useAuthUser } from "@/hooks/auth/useAuth";
import { useTenant } from "../../contexts/TenantContext";
import { savedPropertyService } from "../../api/savedProperties";

export const useSavedProperties = () => {
  const user = useAuthUser();
  const { config } = useTenant();

  return useQuery({
    queryKey: ["savedProperties", user?.id, config?.id],
    queryFn: async () => {
      if (!user?.id || !config?.id) return [];
      return savedPropertyService.getSavedProperties(user.id, config.id);
    },
    enabled: !!user?.id && !!config?.id,
  });
};
